export default __webpack_public_path__ + "static/media/facebook-icon.2737313d.svg";